import vendorAtom from '@src/atom/vendor'
import useCheckAuthQuery from '@src/hooks/queries/auth/checkAuth/useCheckAuthQuery'
import { useCallback } from 'react'
import { useRecoilState } from 'recoil'
import { getAnalytics, setUserId, setUserProperties } from 'firebase/analytics'

const useCheckAuth = () => {
	const [, setVendor] = useRecoilState(vendorAtom)

	const { refetch } = useCheckAuthQuery()
	const checkAuth = useCallback(async () => {
		const response = await refetch()
		if (response.data?.data?.userInfo) {
			const { userInfo } = response.data.data

			const { no, status, username, role } = userInfo
			setVendor((vendorData) => ({
				...vendorData,
				no,
				status,
				username,
				role: role.role,
				isLoggedIn: true,
			}))

			const analytics = getAnalytics()
			setUserId(analytics, no)
			setUserProperties(analytics, {
				username,
			})

			return userInfo
		}
		return null
	}, [refetch, setVendor])
	return { checkAuth }
}
export default useCheckAuth
